/* The Whisper, made ready to read.
   It is kept on the product as one long text, as it was written. Here it becomes its stanzas, each keeping its own
   line breaks. Only what is not the Whisper itself is set aside: the two lines that used to introduce it on the
   earlier page ("The Mirror's Whisper is the voice behind the creation." and "This is what … has to say:"), a
   title standing alone on the first line, the rows of dots between stanzas, and the quotation marks that went
   with the introduction. Not one word of the Whisper is changed. */
(function(){
  const era=window.MirrorEra||{};
  const plain=text=>String(text||'').toLowerCase().replace(/[’‘]/g,"'").replace(/[^a-z0-9']+/g,' ').trim();
  const title=plain(era.title),subtitle=plain(era.subtitle);
  const skip=new Set((Array.isArray(era.whisperSkip)?era.whisperSkip:[]).map(plain));
  const introduction=line=>{
    const said=plain(line);
    return said==="the mirror's whisper is the voice behind the creation"||/^this is what .+ has to say$/.test(said)||skip.has(said);
  };
  const divider=line=>/^[\s·•.*_—–-]+$/.test(line);

  const stanzas=[];let current=[];
  const close=()=>{if(current.length)stanzas.push(current);current=[];};
  String(era.whisper||'').replace(/\r\n?/g,'\n').split('\n').forEach(written=>{
    const line=written.replace(/[ \t ]+/g,' ').trim();
    if(!line||divider(line)||introduction(line)){close();return;}
    current.push(line);
  });
  close();

  // A title alone on the first line is the page's own heading, not part of the letter.
  if(stanzas.length>1&&stanzas[0].length===1&&title){
    const first=plain(stanzas[0][0]);
    if(first===title||first===(title+' '+subtitle).trim()||(subtitle&&first===subtitle))stanzas.shift();
  }

  // The whole letter between one pair of quotation marks: they belonged to "…has to say:".
  const whole=stanzas.map(stanza=>stanza.join('\n')).join('\n\n');
  if(whole[0]==='"'&&(whole.match(/"/g)||[]).length===2){
    const closing=stanzas.findIndex(stanza=>stanza[stanza.length-1].endsWith('"'));
    if(closing>=0){
      stanzas[0][0]=stanzas[0][0].slice(1).trim();
      const stanza=stanzas[closing],last=stanza.length-1;
      stanza[last]=stanza[last].slice(0,-1).trim();
      if(!stanza[last])stanza.pop();
    }
  }

  window.VIULET_PRINTED_PIECE_TEXT={
    'manuscript-front':stanzas.filter(stanza=>stanza.length&&stanza.some(Boolean)).map(stanza=>stanza.filter(Boolean).join('\n')),
    'manuscript-back':[]
  };
})();
